import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityStaff4attendanceImple } from "../../entity/EntityStaff4attendanceImple";

export class DtoStaff4attendancesGetRes extends EntityStaff4attendanceImple {
  public items: EntityStaff4attendanceImple[] = [];
}
